// /src/pages/Sales.js
import React, { Component } from "react";
import { Line } from "react-chartjs-2";

import Backend from "../utils/Backend";
import Notify from "../utils/Notify";
import Currency from "../utils/Currency";

import StatsCard from "./components/stats-cards/StatsCard";

// import React, { Component } from "react";
import { Bar, Pie } from "react-chartjs-2";


/* =========================
   Helpers (safe fallbacks)
========================= */



function normGender(g) {
  const v = safeStr(g).trim().toLowerCase();
  if (!v) return "Prefer not to say";
  if (v.startsWith("m")) return "Male";
  if (v.startsWith("f")) return "Female";
  return "Prefer not to say";
}

const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const MONTHS = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

function normMonth(m) {
  const v = safeStr(m).trim();
  if (!v) return "";
  // if it matches one of MONTHS, return exact casing
  const idx = MONTHS.findIndex((x) => x.toLowerCase() === v.toLowerCase());
  return idx >= 0 ? MONTHS[idx] : v;
}

const CLINKS = {
  primary: "#73113B",
  dark: "#510B29",
  accent: "#FF5E8A",
  accent2: "#F2C08D",
  grid: "rgba(15, 23, 42, 0.08)",
};






function safeStr(v) {
  return v === null || v === undefined ? "" : String(v);
}

function getOrderId(order) {
  return (
    order?.id ||
    order?.order_id ||
    order?.data?.id ||
    order?.number ||
    order?.order_number ||
    ""
  );
}
function getOrderNumber(order) {
  return (
    order?.order_number ||
    order?.number ||
    order?.id ||
    order?.data?.order_number ||
    ""
  );
}
function getCustomerName(order) {
  return (
    safeStr(order?.customer_name) ||
    safeStr(order?.data?.customer_name) ||
    `${safeStr(order?.customer?.user?.first_name)} ${safeStr(
      order?.customer?.user?.last_name
    )}`.trim() ||
    safeStr(order?.user?.name) ||
    ""
  );
}
function getCustomerPhone(order) {
  return (
    safeStr(order?.customer_phone) ||
    safeStr(order?.data?.customer_phone) ||
    safeStr(order?.customer?.user?.phone) ||
    ""
  );
}
function getDeliveryAddress(order) {
  const a =
    order?.delivery_address ||
    order?.data?.delivery_address ||
    order?.data?.customer_address ||
    order?.customer_address ||
    "";
  if (typeof a === "string") return a;

  const line1 = safeStr(a?.address || a?.line1 || a?.street);
  const city = safeStr(a?.city || a?.town);
  const county = safeStr(a?.county);
  const eircode = safeStr(a?.eircode);
  return [line1, city, county, eircode].filter(Boolean).join(", ");
}
function getVendorName(order) {
  return (
    safeStr(order?.vendor_name) ||
    safeStr(order?.data?.vendor_name) ||
    safeStr(order?.venue?.company?.title) ||
    ""
  );
}
function getOrderStatus(order) {
  return (
    safeStr(order?.status) ||
    safeStr(order?.order_status) ||
    safeStr(order?.data?.status) ||
    ""
  );
}
function getDeliveryStatus(order) {
  return (
    safeStr(order?.delivery_status) ||
    safeStr(order?.data?.delivery_status) ||
    safeStr(order?.delivery?.status) ||
    ""
  );
}
function getDeliveredAt(order) {
  return (
    safeStr(order?.delivered_at) ||
    safeStr(order?.data?.delivered_at) ||
    safeStr(order?.delivery?.delivered_at) ||
    safeStr(order?.delivery?.deliveredAt) ||
    safeStr(order?.delivery?.delivered_time) ||
    safeStr(order?.delivery?.deliveredTime) ||
    ""
  );
}
function getDeliveryFeeCents(order) {
  const v =
    order?.delivery_fee ??
    order?.delivery_fee_cents ??
    order?.data?.delivery_fee ??
    order?.data?.delivery_fee_cents ??
    order?.delivery?.fee ??
    order?.delivery?.fee_cents ??
    null;

  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}
function getDistanceKm(order) {
  const v =
    order?.delivery_distance_km ??
    order?.data?.delivery_distance_km ??
    order?.delivery?.distance_km ??
    order?.delivery?.distanceKm ??
    null;

  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}
function getEta(order) {
  return (
    safeStr(order?.delivery_eta) ||
    safeStr(order?.data?.delivery_eta) ||
    safeStr(order?.delivery?.eta) ||
    safeStr(order?.delivery?.estimated_time) ||
    ""
  );
}
function getOrderTotalCents(order) {
  const cents =
    order?.total_cents ??
    order?.payment?.total ??
    order?.total ??
    order?.data?.payment?.total ??
    0;
  const n = Number(cents);
  return Number.isFinite(n) ? n : 0;
}
// function getOrderDay(order) {
//   return safeStr(order?.order_day) || safeStr(order?.day) || "";
// }
// function getOrderDate(order) {
//   return safeStr(order?.order_date) || safeStr(order?.date) || "";
// }
// function getOrderTime(order) {
//   return safeStr(order?.order_time) || safeStr(order?.time) || "";
// }
function getDriverName(order) {
  return (
    safeStr(order?.driver_name) ||
    `${safeStr(order?.driver?.user?.first_name)} ${safeStr(
      order?.driver?.user?.last_name
    )}`.trim() ||
    safeStr(order?.delivery?.driver_name) ||
    ""
  );
}
function getGender(order) {
  return safeStr(order?.gender) || safeStr(order?.customer?.user?.gender) || "";
}
// function getMonth(order) {
//   return safeStr(order?.month) || "";
// }


function getOrderDay(order) {
  return (
    formatOrderDayFromCreatedAt(order) ||
    safeStr(order?.order_day) ||
    safeStr(order?.day) ||
    ""
  );
}

function getOrderDate(order) {
  return (
    formatOrderDateFromCreatedAt(order) ||
    safeStr(order?.order_date) ||
    safeStr(order?.date) ||
    ""
  );
}

function getOrderTime(order) {
  return (
    formatOrderTimeFromCreatedAt(order) ||
    safeStr(order?.order_time) ||
    safeStr(order?.time) ||
    ""
  );
}

function getMonth(order) {
  return (
    formatMonthFromCreatedAt(order) ||
    safeStr(order?.month) ||
    ""
  );
}



function getOrderItems(order) {
  return (
    order?.items ||
    order?.order_items ||
    order?.products ||
    order?.data?.items ||
    []
  );
}
function getItemName(item) {
  return safeStr(item?.product) || safeStr(item?.name) || safeStr(item?.product_name) || "";
}
function getItemQty(item) {
  const q = item?.quantity ?? item?.qty ?? "";
  const n = Number(q);
  return Number.isFinite(n) ? n : q;
}
function getItemPriceCents(item) {
  const cents = item?.price_cents ?? item?.price ?? item?.unit_price ?? 0;
  const n = Number(cents);
  return Number.isFinite(n) ? n : 0;
}
function getItemTotalCents(item) {
  const cents = item?.total_cents ?? item?.total ?? 0;
  const n = Number(cents);
  if (Number.isFinite(n) && n > 0) return n;
  const qty = Number(getItemQty(item) || 0);
  return qty * getItemPriceCents(item);
}



function getCreatedAt(order) {
  return (
    order?.created_at ||
    order?.createdAt ||
    order?.data?.created_at ||
    order?.data?.createdAt ||
    ""
  );
}

function parseCreatedAt(order) {
  const value = getCreatedAt(order);
  if (!value) return null;

  // Firestore timestamp support
  if (value?.seconds) {
    return new Date(value.seconds * 1000);
  }

  // Django / ISO date string support
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function formatOrderDateFromCreatedAt(order) {
  const d = parseCreatedAt(order);
  if (!d) return "";

  const day = String(d.getDate()).padStart(2, "0");
  const month = MONTHS[d.getMonth()]?.slice(0, 3) || "";
  const year = String(d.getFullYear()).slice(-2);

  return `${day}-${month}-${year}`;
}

function formatOrderTimeFromCreatedAt(order) {
  const d = parseCreatedAt(order);
  if (!d) return "";

  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
}

function formatOrderDayFromCreatedAt(order) {
  const d = parseCreatedAt(order);
  if (!d) return "";

  // JS Sunday = 0, but your WEEKDAYS starts Monday
  const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return dayNames[d.getDay()];
}

function formatMonthFromCreatedAt(order) {
  const d = parseCreatedAt(order);
  if (!d) return "";

  return MONTHS[d.getMonth()] || "";
}




function isOrderAccepted(order) {
  const status = safeStr(getOrderStatus(order)).trim().toLowerCase();
  const deliveryStatus = safeStr(getDeliveryStatus(order)).trim().toLowerCase();

  return (
    status === "accepted" ||
    status === "completed" ||
    status === "delivered" ||
    deliveryStatus === "accepted" ||
    deliveryStatus === "out_for_delivery" ||
    deliveryStatus === "delivered"
  );
}




/* =========================
   ✅ Example data (demo)
========================= */
const EXAMPLE_SALES_ORDERS = [
  {
    id: 193,
    order_number: "193",
    customer_name: "Danielle Gibbons",
    delivery_address: "17 Beechtree Ave, Cork",
    customer_phone: "353862010557",
    status: "Accepted",
    delivery_status: "Delivered",
    delivered_at: "02-Jan-24 19:40",
    delivery_fee_cents: 450,
    delivery_distance_km: 4.2,
    delivery_eta: "45 mins",
    total_cents: 2270,
    order_day: "Tuesday",
    order_date: "02-Jan-24",
    order_time: "18:55:00",
    driver_name: "Sean Mooney",
    gender: "Female",
    month: "January",
    vendor_name: "Number 21",
    items: [
      { product: "Graham Norton Sauv", quantity: 1, price_cents: 1610, total_cents: 1610 },
      { product: "SCHWEPPES SODA WATER 1 Ltr", quantity: 1, price_cents: 330, total_cents: 330 },
      { product: "SCHWEPPES SLIMLINE TONIC WATER 1 Ltr", quantity: 1, price_cents: 330, total_cents: 330 },
    ],
  },
  {
    id: 194,
    order_number: "194",
    customer_name: "Axolile Lungu",
    delivery_address: "T12 W599, Cork",
    customer_phone: "353838976667",
    status: "Accepted",
    delivery_status: "Delivered",
    delivered_at: "03-Jan-24 22:05",
    delivery_fee_cents: 400,
    delivery_distance_km: 3.5,
    delivery_eta: "40 mins",
    total_cents: 1840,
    order_day: "Wednesday",
    order_date: "03-Jan-24",
    order_time: "21:12:00",
    driver_name: "Andrew Scannell",
    gender: "Male",
    month: "January",
    vendor_name: "Scally's",
    items: [{ product: "Canto Novo Pinot Grigio", quantity: 2, price_cents: 920, total_cents: 1840 }],
  },
  {
    id: 200,
    order_number: "200",
    customer_name: "Cian Barry",
    delivery_address: "Dorgan's Road, Cork",
    customer_phone: "353879311281",
    status: "Accepted",
    delivery_status: "Delivered",
    delivered_at: "13-Jan-24 11:25",
    delivery_fee_cents: 500,
    delivery_distance_km: 6.1,
    delivery_eta: "55 mins",
    total_cents: 2980,
    order_day: "Saturday",
    order_date: "13-Jan-24",
    order_time: "10:41:00",
    driver_name: "Andrew Scannell",
    gender: "Male",
    month: "January",
    vendor_name: "Number 21",
    items: [
      { product: "Rockshore Cider 500ml 8 Pack Cans", quantity: 1, price_cents: 2175, total_cents: 2175 },
      { product: "COORS LIGHT CANS 500ML 4 PACK", quantity: 1, price_cents: 805, total_cents: 805 },
    ],
  },
];

/* =========================
   Component
========================= */
export default class Sales extends Component {
  constructor(props) {
    super(props);

    this.state = {
      graphStats: [],
      monthlyStats: [],
      totalEarnings: [],
      graphs: null,

      // ✅ Sales Table
      salesOrders: [],
      isLoading: true,
      isLoadingOrders: false,

      expanded: {},
      searchTerm: "",

      // ✅ demo toggle
      useDemoData: false,   // ✅ make real API default


      statusFilter: "",
      deliveryStatusFilter: "",
      dayFilter: "",
      monthFilter: "",
      genderFilter: "",
      vendorFilter: "",
      driverFilter: "",
      dateFrom: "",
      dateTo: "",

      currentPage: 1,
      pageSize: 10,

    };
  }

  // componentDidMount() {
  //   this._getGraphStats();
  //   this._getMonthlyStats();
  //   this._getTotalEarnings();

  //   // ✅ start with demo data (so you can see the table immediately)
  //   this.setState({ salesOrders: EXAMPLE_SALES_ORDERS, isLoading: false }, () => {
  //     if (!this.state.useDemoData) this._getSalesOrders();
  //   });
  // }





  componentDidMount() {
  this._getGraphStats();
  // this._getMonthlyStats();
  this._getTotalEarnings();

  if (this.state.useDemoData) {
    this.setState({ salesOrders: EXAMPLE_SALES_ORDERS, isLoading: false });
  } else {
    this.setState({ isLoading: false }, () => this._getSalesOrders());
  }
}

_getPaginatedRows(rows) {
  const { currentPage, pageSize } = this.state;

  const start = (currentPage - 1) * pageSize;
  const end = start + pageSize;

  return rows.slice(start, end);
}

_getTotalPages(totalRows) {
  const { pageSize } = this.state;
  return Math.max(1, Math.ceil(totalRows / pageSize));
}

_goToPage(page, totalPages) {
  const safePage = Math.min(Math.max(page, 1), totalPages);
  this.setState({ currentPage: safePage });
}


_getSalesByGenderData() {
  // const { salesOrders } = this.state;
  const salesOrders = this._filteredSalesOrders();
  const counts = { Female: 0, Male: 0, "Prefer not to say": 0 };

  (salesOrders || []).forEach((o) => {
    const g = normGender(getGender(o));
    counts[g] = (counts[g] || 0) + 1;
  });

  return {
    labels: Object.keys(counts),
    datasets: [
      {
        label: "Orders",
        data: Object.values(counts),
        backgroundColor: [CLINKS.accent, CLINKS.primary, "rgba(115, 17, 59, 0.25)"],
        borderColor: ["#fff", "#fff", "#fff"],
        borderWidth: 2,
      },
    ],
  };
}


_getSalesByDayData() {
  // const { salesOrders } = this.state;
  const salesOrders = this._filteredSalesOrders();
  const counts = WEEKDAYS.reduce((acc, d) => ((acc[d] = 0), acc), {});

  (salesOrders || []).forEach((o) => {
    const dayRaw = safeStr(getOrderDay(o)).trim();
    const day = WEEKDAYS.find((d) => d.toLowerCase() === dayRaw.toLowerCase()) || "";
    if (day) counts[day] += 1;
  });

  return {
    labels: WEEKDAYS,
    datasets: [
      {
        label: "Orders",
        data: WEEKDAYS.map((d) => counts[d] || 0),
        backgroundColor: "rgba(115, 17, 59, 0.25)",
        borderColor: CLINKS.primary,
        borderWidth: 2,
        hoverBackgroundColor: "rgba(81, 11, 41, 0.25)",
      },
    ],
  };
}


_getAvgSpendPerOrderData() {
  // const { salesOrders } = this.state;
  const salesOrders = this._filteredSalesOrders();
  const bucket = {};

  (salesOrders || []).forEach((o) => {
    const m = normMonth(getMonth(o));
    if (!m) return;

    const cents = getOrderTotalCents(o) || 0;
    if (!bucket[m]) bucket[m] = { sum: 0, count: 0 };

    bucket[m].sum += cents;
    bucket[m].count += 1;
  });

  const labels = MONTHS.filter((m) => bucket[m]?.count);
  const avgEuros = labels.map((m) => {
    const b = bucket[m];
    if (!b || !b.count) return 0;
    return (b.sum / b.count) / 100;
  });

  return {
    labels,
    datasets: [
      {
        label: "Avg Spend (€)",
        data: avgEuros,
        borderColor: CLINKS.primary,
        backgroundColor: "rgba(115, 17, 59, 0.12)",
        pointBackgroundColor: CLINKS.dark,
        pointBorderColor: "#fff",
        pointBorderWidth: 2,
        pointRadius: 5,
        tension: 0.35,
        fill: true,
        borderWidth: 3,
      },
    ],
  };
}



_getCommonOptions() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom" },
      tooltip: { mode: "index", intersect: false },
    },
    scales: {
      x: {
        grid: { color: CLINKS.grid },
        ticks: { color: CLINKS.dark },
      },
      y: {
        grid: { color: CLINKS.grid },
        ticks: { color: CLINKS.dark },
      },
    },
  };
}

_getPieOptions() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "right" },
    },
  };
}




  _getGraphStats() {
    Backend.getDailyStats()
      .then((graphStats) => {
        this.setState({ graphStats });

        const graphMap = graphStats?.total || [];
        const date = graphMap.map((s) => s?.date);
        const salesCount = graphMap.map((s) => s?.sales_count);
        const totalEarnings = graphMap.map((s) => (s?.earnings || 0) / 100);

        const graphData = {
          labels: date,
          datasets: [
            {
              label: "Value of Sales",
              data: totalEarnings,
              fill: true,
              borderColor: "#1BC5BD",
              borderWidth: 4,
              pointDot: false,
              backgroundColor: "rgba(75,192,192,0.2)",
            },
            {
              label: "Amount of Sales",
              data: salesCount,
              fill: true,
              borderColor: "#73113b",
              borderWidth: 4,
              pointDot: false,
              backgroundColor: "rgb(255,0,0, 0.3)",
            },
          ],
        };

        this.setState({ graphs: graphData, isLoading: false });
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  _getTotalEarnings() {
    this.setState({ isLoading: true });

    Backend.getTotalEarnings()
      .then((totalEarnings) => {
        this.setState({ totalEarnings, isLoading: false });
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  // _getMonthlyStats() {
  //   this.setState({ isLoading: true });

  //   Backend.getMonthlyStats()
  //     .then((monthlyStats) => {
  //       this.setState({ monthlyStats, isLoading: false });
  //     })
  //     .catch((error) => {
  //       Notify.error(error.message);
  //       this.setState({ isLoading: false });
  //     });
  // }



_getAcceptedSalesOrders() {
  const { salesOrders } = this.state;

  return (salesOrders || []).filter((order) => {
    return isOrderAccepted(order);
  });
}


  // _getMonthlySales() {
  // const rows = this._filteredSalesOrders();
  // const now = new Date();
  // const currentMonth = now.getMonth();
  // const currentYear = now.getFullYear();

  // return (rows || []).filter((order) => {
  //   const createdAt = parseCreatedAt(order);

  //   if (!createdAt) {
  //     return false;
  //   }

  //   return (
  //     createdAt.getMonth() === currentMonth &&
  //     createdAt.getFullYear() === currentYear
  //     );
  //   }).length;
  // }


  _getMonthlySales() {
  const rows = this._getAcceptedSalesOrders();

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  return (rows || []).filter((order) => {
    const createdAt = parseCreatedAt(order);

    if (!createdAt) {
      return false;
    }

    return (
      createdAt.getMonth() === currentMonth &&
      createdAt.getFullYear() === currentYear
    );
  }).length;
}




  // ✅ optional: real API fetch for table (only if your Backend has it)
  // _getSalesOrders() {
  //   this.setState({ isLoadingOrders: true });

  //   const fn = Backend.getSalesOrders || Backend.getOrders || null;

  //   if (!fn) {
  //     this.setState({ isLoadingOrders: false });
  //     Notify.error("Backend.getSalesOrders() not found (still showing demo table).");
  //     return;
  //   }

  //   fn()
  //     .then((salesOrders) => {
  //       const normalizedOrders = Array.isArray(salesOrders)
  //         ? salesOrders
  //         : Array.isArray(salesOrders?.results)
  //         ? salesOrders.results
  //         : Array.isArray(salesOrders?.data)
  //         ? salesOrders.data
  //         : [];

  //       this.setState({
  //         salesOrders: normalizedOrders,
  //         isLoadingOrders: false,
  //       });
  //     })
  //     .catch((error) => {
  //       Notify.error(error.message);
  //       this.setState({ isLoadingOrders: false });
  //     });
  // }

  async _getSalesOrders() {
  this.setState({ isLoadingOrders: true });

  const fn = Backend.getSalesOrders || Backend.getOrders || null;

  if (!fn) {
    this.setState({ isLoadingOrders: false });
    Notify.error("Backend.getSalesOrders() not found.");
    return;
  }

  try {
    let page = 1;
    let allOrders = [];
    let hasMore = true;

    while (hasMore) {
      const res = await fn({
        page,
        page_size: 100,
        pagination_type: "page",
      });

      const pageOrders = Array.isArray(res)
        ? res
        : Array.isArray(res?.results)
        ? res.results
        : Array.isArray(res?.data)
        ? res.data
        : [];

      allOrders = [...allOrders, ...pageOrders];

      const totalCount = res?.count || res?.total || res?.total_count;

      if (totalCount) {
        hasMore = allOrders.length < totalCount;
      } else {
        hasMore = pageOrders.length === 100;
      }

      page += 1;
    }

    this.setState({
      salesOrders: allOrders,
      isLoadingOrders: false,
      currentPage: 1,
    });
  } catch (error) {
    Notify.error(error.message);
    this.setState({ isLoadingOrders: false });
  }
}

  _renderGraphs() {
    const { graphs, isLoading } = this.state;
    if (isLoading) return null;
    return graphs ? <Line data={graphs} /> : null;
  }

  // _getWeeklySales() {
  //   const { graphStats } = this.state;
  //   return graphStats?.total?.reduce((sum, s) => sum + (s.sales_count || 0), 0) || 0;
  // }

  _getWeeklySales() {
  const rows = this._getAcceptedSalesOrders();

  const now = new Date();

  const startOfWeek = new Date(now);
  const day = startOfWeek.getDay(); // Sunday = 0
  const diffToMonday = day === 0 ? -6 : 1 - day;

  startOfWeek.setDate(startOfWeek.getDate() + diffToMonday);
  startOfWeek.setHours(0, 0, 0, 0);

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  endOfWeek.setHours(23, 59, 59, 999);

  return (rows || []).filter((order) => {
    const createdAt = parseCreatedAt(order);

    if (!createdAt) {
      return false;
    }

    return createdAt >= startOfWeek && createdAt <= endOfWeek;
  }).length;
}


_getAcceptedTotalRevenue() {
  const rows = this._getAcceptedSalesOrders();

  return (rows || []).reduce((sum, order) => {
    return sum + getOrderTotalCents(order);
  }, 0);
}
  // _getMonthlySales() {
  //   const { monthlyStats } = this.state;
  //   console.log("_getMonthlySales monthlyStats:", monthlyStats);
  //   return monthlyStats?.total?.reduce((sum, s) => sum + (s.sales_count || 0), 0) || 0;
  // }

  _setExpanded(order, value) {
    const id = getOrderId(order) || getOrderNumber(order);
    this.setState((prev) => ({
      expanded: { ...prev.expanded, [id]: value },
    }));
  }

  _getExpanded(order) {
    const id = getOrderId(order) || getOrderNumber(order);
    return !!this.state.expanded[id];
  }

  _getUniqueOptions(keyFn) {
  const { salesOrders } = this.state;

  return Array.from(
    new Set(
      (salesOrders || [])
        .map((o) => safeStr(keyFn(o)).trim())
        .filter(Boolean)
    )
  ).sort((a, b) => a.localeCompare(b));
}

_resetSalesFilters() {
  this.setState({
    searchTerm: "",
    statusFilter: "",
    deliveryStatusFilter: "",
    dayFilter: "",
    monthFilter: "",
    genderFilter: "",
    vendorFilter: "",
    driverFilter: "",
    dateFrom: "",
    dateTo: "",
    currentPage:1,
  });
}

_parseOrderDate(dateStr) {
  const v = safeStr(dateStr).trim();
  if (!v) return null;

  // Handles yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const d = new Date(`${v}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  // Handles dd-MMM-yy like 02-Jan-24
  const match = v.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{2,4})$/);
  if (match) {
    const day = Number(match[1]);
    const monthText = match[2].toLowerCase();
    let year = Number(match[3]);

    if (year < 100) year += 2000;

    const monthMap = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11,
    };

    const month = monthMap[monthText];
    if (month === undefined) return null;

    const d = new Date(year, month, day);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

  // _filteredSalesOrders() {
  //   const { salesOrders, searchTerm } = this.state;
  //   const q = safeStr(searchTerm).trim().toLowerCase();
  //   if (!q) return salesOrders;

  //   return (salesOrders || []).filter((o) => {
  //     const hay = [
  //       getOrderNumber(o),
  //       getCustomerName(o),
  //       getDeliveryAddress(o),
  //       getCustomerPhone(o),
  //       getOrderStatus(o),
  //       getDeliveryStatus(o),
  //       getDriverName(o),
  //       getVendorName(o),
  //       getMonth(o),
  //       getOrderDate(o),
  //     ]
  //       .map((x) => safeStr(x).toLowerCase())
  //       .join(" | ");

  //     return hay.includes(q);
  //   });
  // }



//   _filteredSalesOrders() {
//   const {
//     salesOrders,
//     searchTerm,
//     statusFilter,
//     deliveryStatusFilter,
//     dayFilter,
//     monthFilter,
//     genderFilter,
//     vendorFilter,
//     driverFilter,
//     dateFrom,
//     dateTo,
//   } = this.state;

//   const q = safeStr(searchTerm).trim().toLowerCase();

//   const fromDate = dateFrom ? new Date(`${dateFrom}T00:00:00`) : null;
//   const toDate = dateTo ? new Date(`${dateTo}T23:59:59`) : null;

//   return (salesOrders || []).filter((o) => {
//     const orderStatus = safeStr(getOrderStatus(o)).trim();
//     const deliveryStatus = safeStr(getDeliveryStatus(o)).trim();
//     const orderDay = safeStr(getOrderDay(o)).trim();
//     const orderMonth = normMonth(getMonth(o));
//     const gender = normGender(getGender(o));
//     const vendor = safeStr(getVendorName(o)).trim();
//     const driver = safeStr(getDriverName(o)).trim();
//     const orderDateRaw = getOrderDate(o);
//     const orderDate = this._parseOrderDate(orderDateRaw);

//     if (statusFilter && orderStatus !== statusFilter) return false;
//     if (deliveryStatusFilter && deliveryStatus !== deliveryStatusFilter) return false;
//     if (dayFilter && orderDay !== dayFilter) return false;
//     if (monthFilter && orderMonth !== monthFilter) return false;
//     if (genderFilter && gender !== genderFilter) return false;
//     if (vendorFilter && vendor !== vendorFilter) return false;
//     if (driverFilter && driver !== driverFilter) return false;

//     if (fromDate && orderDate && orderDate < fromDate) return false;
//     if (toDate && orderDate && orderDate > toDate) return false;

//     if (fromDate && !orderDate) return false;
//     if (toDate && !orderDate) return false;

//     if (!q) return true;

//     const hay = [
//       getOrderNumber(o),
//       getCustomerName(o),
//       getDeliveryAddress(o),
//       getCustomerPhone(o),
//       orderStatus,
//       deliveryStatus,
//       driver,
//       vendor,
//       orderMonth,
//       orderDateRaw,
//       orderDay,
//       gender,
//     ]
//       .map((x) => safeStr(x).toLowerCase())
//       .join(" | ");

//     return hay.includes(q);
//   });
// }












_filteredSalesOrders() {
  const {
    salesOrders,
    searchTerm,
    statusFilter,
    deliveryStatusFilter,
    dayFilter,
    monthFilter,
    genderFilter,
    vendorFilter,
    driverFilter,
    dateFrom,
    dateTo,
  } = this.state;

  const q = safeStr(searchTerm).trim().toLowerCase();

  const fromDate = dateFrom ? new Date(`${dateFrom}T00:00:00`) : null;
  const toDate = dateTo ? new Date(`${dateTo}T23:59:59`) : null;

  return (salesOrders || []).filter((o) => {
    // ✅ IMPORTANT: sales table should depend on accepted orders only
    // if (!isOrderAccepted(o)) {
    //   return false;
    // }

    const orderStatus = safeStr(getOrderStatus(o)).trim();
    const deliveryStatus = safeStr(getDeliveryStatus(o)).trim();
    const orderDay = safeStr(getOrderDay(o)).trim();
    const orderMonth = normMonth(getMonth(o));
    const gender = normGender(getGender(o));
    const vendor = safeStr(getVendorName(o)).trim();
    const driver = safeStr(getDriverName(o)).trim();
    const orderDateRaw = getOrderDate(o);
    const orderDate = this._parseOrderDate(orderDateRaw);

    if (statusFilter && orderStatus !== statusFilter) return false;
    if (deliveryStatusFilter && deliveryStatus !== deliveryStatusFilter) return false;
    if (dayFilter && orderDay !== dayFilter) return false;
    if (monthFilter && orderMonth !== monthFilter) return false;
    if (genderFilter && gender !== genderFilter) return false;
    if (vendorFilter && vendor !== vendorFilter) return false;
    if (driverFilter && driver !== driverFilter) return false;

    if (fromDate && orderDate && orderDate < fromDate) return false;
    if (toDate && orderDate && orderDate > toDate) return false;

    if (fromDate && !orderDate) return false;
    if (toDate && !orderDate) return false;

    if (!q) return true;

    const hay = [
      getOrderNumber(o),
      getCustomerName(o),
      getDeliveryAddress(o),
      getCustomerPhone(o),
      orderStatus,
      deliveryStatus,
      driver,
      vendor,
      orderMonth,
      orderDateRaw,
      orderDay,
      gender,
    ]
      .map((x) => safeStr(x).toLowerCase())
      .join(" | ");

    return hay.includes(q);
  });
}












  _renderSalesTable() {
  // const { isLoadingOrders, searchTerm, useDemoData } = this.state;
  // const rows = this._filteredSalesOrders();
  const {
  isLoadingOrders,
  searchTerm,
  useDemoData,
  statusFilter,
  deliveryStatusFilter,
  dayFilter,
  monthFilter,
  genderFilter,
  vendorFilter,
  driverFilter,
  dateFrom,
  dateTo,
} = this.state;
 const rows = this._filteredSalesOrders();

 const totalPages = this._getTotalPages(rows.length);
const paginatedRows = this._getPaginatedRows(rows);

 console.log("_renderSalesTable rows: ", rows);

 const statusOptions = this._getUniqueOptions(getOrderStatus);
const deliveryStatusOptions = this._getUniqueOptions(getDeliveryStatus);
const dayOptions = WEEKDAYS;
const monthOptions = MONTHS;
const genderOptions = ["Male", "Female", "Prefer not to say"];
const vendorOptions = this._getUniqueOptions(getVendorName);
const driverOptions = this._getUniqueOptions(getDriverName);

  // ✅ Theme styles (Clinks)
  const styles = {
    tableWrap: { overflowX: "auto" },

    groupTh: {
      background: "#510B29",
      color: "#fff",
      textTransform: "uppercase",
      fontSize: 11,
      letterSpacing: "0.08em",
      padding: "10px 12px",
      border: "1px solid rgba(255,255,255,0.14)",
      whiteSpace: "nowrap",
    },

    th: {
      background: "#73113B",
      color: "#fff",
      fontWeight: 700,
      fontSize: 13,
      padding: "10px 12px",
      border: "1px solid rgba(255,255,255,0.12)",
      whiteSpace: "nowrap",
    },

    // sticky header wrapper (works while horizontal scrolling)
    theadSticky: {
      position: "sticky",
      top: 0,
      zIndex: 3,
      boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    },

    // inner expanded table header
    subTh: {
      background: "#510B29",
      color: "#fff",
      fontWeight: 700,
      fontSize: 12,
      padding: "8px 10px",
      border: "1px solid rgba(255,255,255,0.12)",
      whiteSpace: "nowrap",
    },

    subGroupTh: {
      background: "#0F172A",
      color: "#fff",
      textTransform: "uppercase",
      fontSize: 10,
      letterSpacing: "0.08em",
      padding: "8px 10px",
      border: "1px solid rgba(255,255,255,0.12)",
      whiteSpace: "nowrap",
    },

    expandedCell: {
      background: "#fafafa",
      borderTop: "2px solid #E5E7EB",
    },
  };

  return (
    <div className="card card-custom gutter-b">
      <div className="card-header">
        <div className="card-title">
          <h3 className="card-label">Sales Table</h3>
        </div>

        {/* <div className="card-toolbar d-flex" style={{ gap: 10 }}>
          <div style={{ minWidth: 280 }}>
            <input
              className="form-control"
              placeholder="Search order, customer, vendor, status..."
              value={searchTerm}
              onChange={(e) => this.setState({ searchTerm: e.target.value })}
            />
          </div>

          <label className="d-flex align-items-center mb-0" style={{ gap: 8 }}>
            <input
              type="checkbox"
              checked={useDemoData}
              onChange={(e) => {
                const checked = e.target.checked;
                this.setState(
                  {
                    useDemoData: checked,
                    salesOrders: checked ? EXAMPLE_SALES_ORDERS : [],
                    expanded: {},
                  },
                  () => {
                    if (!checked) this._getSalesOrders();
                  }
                );
              }}
            />
            <span className="small text-muted">Use demo data</span>
          </label>
        </div> */}



          <div
  className="card-toolbar d-flex flex-wrap align-items-center"
  style={{ gap: 10 }}
>
  <div style={{ minWidth: 260 }}>
    {/* <input
      className="form-control"
      placeholder="Search order, customer, vendor, status..."
      value={searchTerm}
      onChange={(e) => this.setState({ searchTerm: e.target.value })}
    /> */}


      <input
  className="form-control"
  placeholder="Search order, customer, vendor, status..."
  value={searchTerm}
  onChange={(e) =>
    this.setState({
      searchTerm: e.target.value,
      currentPage: 1,
    })
  }
/>


  </div>

  <select
    className="form-control"
    style={{ width: 170 }}
    value={statusFilter}
    onChange={(e) => this.setState({ statusFilter: e.target.value, currentPage:1 })}
  >
    <option value="">All Status</option>
    {statusOptions.map((s) => (
      <option key={s} value={s}>
        {s}
      </option>
    ))}
  </select>

  <select
    className="form-control"
    style={{ width: 190 }}
    value={deliveryStatusFilter}
    onChange={(e) => this.setState({ deliveryStatusFilter: e.target.value,  currentPage:1  })}
  >
    <option value="">All Delivery Status</option>
    {deliveryStatusOptions.map((s) => (
      <option key={s} value={s}>
        {s}
      </option>
    ))}
  </select>

  <select
    className="form-control"
    style={{ width: 150 }}
    value={dayFilter}
    onChange={(e) => this.setState({ dayFilter: e.target.value,  currentPage:1  })}
  >
    <option value="">All Days</option>
    {dayOptions.map((d) => (
      <option key={d} value={d}>
        {d}
      </option>
    ))}
  </select>

  <select
    className="form-control"
    style={{ width: 160 }}
    value={monthFilter}
    onChange={(e) => this.setState({ monthFilter: e.target.value,  currentPage:1  })}
  >
    <option value="">All Months</option>
    {monthOptions.map((m) => (
      <option key={m} value={m}>
        {m}
      </option>
    ))}
  </select>

  <select
    className="form-control"
    style={{ width: 170 }}
    value={genderFilter}
    onChange={(e) => this.setState({ genderFilter: e.target.value,  currentPage:1  })}
  >
    <option value="">All Gender</option>
    {genderOptions.map((g) => (
      <option key={g} value={g}>
        {g}
      </option>
    ))}
  </select>

  <select
    className="form-control"
    style={{ width: 180 }}
    value={vendorFilter}
    onChange={(e) => this.setState({ vendorFilter: e.target.value,  currentPage:1  })}
  >
    <option value="">All Vendors</option>
    {vendorOptions.map((v) => (
      <option key={v} value={v}>
        {v}
      </option>
    ))}
  </select>

  <select
    className="form-control"
    style={{ width: 180 }}
    value={driverFilter}
    onChange={(e) => this.setState({ driverFilter: e.target.value,  currentPage:1  })}
  >
    <option value="">All Drivers</option>
    {driverOptions.map((d) => (
      <option key={d} value={d}>
        {d}
      </option>
    ))}
  </select>

  <select
  className="form-control"
  style={{ width: 130 }}
  value={this.state.pageSize}
  onChange={(e) =>
    this.setState({
      pageSize: Number(e.target.value),
      currentPage: 1,
    })
  }
>
  <option value={5}>5 rows</option>
  <option value={10}>10 rows</option>
  <option value={20}>20 rows</option>
  <option value={50}>50 rows</option>
  <option value={100}>100 rows</option>
</select>

  <input
    type="date"
    className="form-control"
    style={{ width: 160 }}
    value={dateFrom}
    onChange={(e) => this.setState({ dateFrom: e.target.value })}
  />

  <input
    type="date"
    className="form-control"
    style={{ width: 160 }}
    value={dateTo}
    onChange={(e) => this.setState({ dateTo: e.target.value })}
  />

  <button
    className="btn btn-light-primary"
    onClick={() => this._resetSalesFilters()}
  >
    Reset
  </button>

  <span className="badge badge-light-dark">
    Showing {rows.length} / {(this.state.salesOrders || []).length}
  </span>

  <label className="d-flex align-items-center mb-0" style={{ gap: 8 }}>
    <input
      type="checkbox"
      checked={useDemoData}
      onChange={(e) => {
        const checked = e.target.checked;
        this.setState(
          {
            useDemoData: checked,
            salesOrders: checked ? EXAMPLE_SALES_ORDERS : [],
            expanded: {},
          },
          () => {
            if (!checked) this._getSalesOrders();
          }
        );
      }}
    />
    <span className="small text-muted">Use demo data</span>
  </label>
</div>


      </div>







                      {/* ✅ NEW: INSIGHTS CHARTS */}
        <div className="row wd-100 mb-5">
          <div className="col-lg-4 col-md-12 mb-4">
            <div className="card card-custom gutter-b h-100">
              <div className="card-header">
                <div className="card-title">
                  <h3 className="card-label">Sales by Gender</h3>
                </div>
              </div>
              <div className="card-body" style={{ minHeight: 280 }}>
                <Pie data={this._getSalesByGenderData()} />
              </div>
            </div>
          </div>

          <div className="col-lg-8 col-md-12 mb-4">
            <div className="card card-custom gutter-b h-100">
              <div className="card-header">
                <div className="card-title">
                  <h3 className="card-label">Avg Customer Spend Per Order (€)</h3>
                </div>
              </div>
              <div className="card-body" style={{ minHeight: 280 }}>
                <Line data={this._getAvgSpendPerOrderData()} />
              </div>
            </div>
          </div>
        </div>

        <div className="row wd-100 mb-5">
          <div className="col-md-12">
            <div className="card card-custom gutter-b">
              <div className="card-header">
                <div className="card-title">
                  <h3 className="card-label">Sales by Day</h3>
                </div>
              </div>
              <div className="card-body" style={{ minHeight: 280 }}>
                <Bar data={this._getSalesByDayData()} />
              </div>
            </div>
          </div>
        </div>








      <div className="card-body" style={styles.tableWrap}>
        {isLoadingOrders ? (
          <div className="text-muted">Loading sales table...</div>
        ) : (
          <table
            className="table table-bordered table-hover mb-0"
            style={{ minWidth: 1200, borderCollapse: "separate", borderSpacing: 0 }}
          >
            {/* ✅ THEMED + GROUPED + STICKY HEADER */}
            <thead style={styles.theadSticky}>
              <tr>
                <th colSpan={2} style={styles.groupTh}>ORDER</th>
                <th colSpan={3} style={styles.groupTh}>CUSTOMER</th>
                <th colSpan={2} style={styles.groupTh}>STATUS</th>
                <th colSpan={1} style={styles.groupTh}>PAYMENT</th>
                <th colSpan={5} style={styles.groupTh}>TIME & PEOPLE</th>
                <th colSpan={3} style={styles.groupTh}>VENDOR</th>
              </tr>

              <tr>
                <th style={{ ...styles.th, width: 60 }}>Order</th>
                <th style={styles.th}>Order Number</th>

                <th style={styles.th}>Customer Name</th>
                <th style={styles.th}>Delivery Address</th>
                <th style={styles.th}>Customer Phone</th>

                <th style={styles.th}>Status</th>
                <th style={styles.th}>Delivery Status</th>

                <th style={styles.th}>Cost</th>

                <th style={styles.th}>Order Day</th>
                <th style={styles.th}>Order Date</th>
                <th style={styles.th}>Order Time</th>
                <th style={styles.th}>Driver</th>
                <th style={styles.th}>Gender</th>

                <th style={styles.th}>Month</th>
                <th style={styles.th}>Vendor</th>
                <th style={styles.th}>Vendor Products</th>
              </tr>
            </thead>

            <tbody>
              {(paginatedRows || []).length === 0 ? (
                <tr>
                  <td colSpan={16} className="text-center text-muted">
                    No sales found
                  </td>
                </tr>
              ) : (
                paginatedRows.map((order, idx) => {
                  const expanded = this._getExpanded(order);
                  const items = getOrderItems(order);
                  const orderNo = getOrderNumber(order);
                  const orderId = getOrderId(order) || orderNo || idx;

                  const productsCount = Array.isArray(items) ? items.length : 0;

                  return (
                    <React.Fragment key={orderId}>
                      <tr
                        style={{ cursor: "pointer" }}
                        onClick={() => this._setExpanded(order, !expanded)}
                        title="Click to expand products"
                      >
                        {/* <td className="text-center">{idx + 1}</td> */}
                        <td className="text-center">
                          {(this.state.currentPage - 1) * this.state.pageSize + idx + 1}
                        </td>
                        <td>
                          <span className="font-weight-bolder">{orderNo}</span>
                        </td>
                        <td>{getCustomerName(order)}</td>
                        <td>{getDeliveryAddress(order)}</td>
                        <td>{getCustomerPhone(order)}</td>
                        <td>{getOrderStatus(order)}</td>
                        <td>{getDeliveryStatus(order)}</td>
                        <td>
                          {Currency.format
                            ? Currency.format(getOrderTotalCents(order))
                            : `€${(getOrderTotalCents(order) / 100).toFixed(2)}`}
                        </td>
                        <td>{getOrderDay(order)}</td>
                        <td>{getOrderDate(order)}</td>
                        <td>{getOrderTime(order)}</td>
                        <td>{getDriverName(order)}</td>
                        <td>{getGender(order)}</td>
                        <td>{getMonth(order)}</td>
                        <td>{getVendorName(order)}</td>
                        <td className="text-center">{productsCount}</td>
                      </tr>

                      {/* ✅ EXPANDED: PRODUCTS TABLE WITH DELIVERY DETAILS PER PRODUCT */}
                      {expanded && (
                        <tr>
                          <td colSpan={16} style={styles.expandedCell}>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <div className="font-weight-bolder">
                                Products + Delivery Details for Order #{orderNo}
                              </div>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this._setExpanded(order, false);
                                }}
                              >
                                Close
                              </button>
                            </div>

                            <div style={{ overflowX: "auto" }}>
                              <table
                                className="table table-sm table-striped mb-0"
                                style={{ minWidth: 1400, borderCollapse: "separate", borderSpacing: 0 }}
                              >
                                <thead>
                                  {/* ✅ GROUPED HEADER FOR SUBTABLE */}
                                  <tr>
                                    <th colSpan={5} style={styles.subGroupTh}>PRODUCTS</th>
                                    <th colSpan={7} style={styles.subGroupTh}>DELIVERY DETAILS</th>
                                  </tr>

                                  <tr>
                                    <th style={styles.subTh}>Order Number</th>
                                    <th style={styles.subTh}>Product</th>
                                    <th style={{ ...styles.subTh, width: 120 }}>Quantity</th>
                                    <th style={{ ...styles.subTh, width: 140 }}>Price</th>
                                    <th style={{ ...styles.subTh, width: 140 }}>Total</th>

                                    <th style={styles.subTh}>Delivery Address</th>
                                    <th style={{ ...styles.subTh, width: 140 }}>Delivery Status</th>
                                    <th style={{ ...styles.subTh, width: 140 }}>Delivery Fee</th>
                                    <th style={{ ...styles.subTh, width: 140 }}>Distance (KM)</th>
                                    <th style={{ ...styles.subTh, width: 140 }}>ETA</th>
                                    <th style={{ ...styles.subTh, width: 160 }}>Driver</th>
                                    <th style={{ ...styles.subTh, width: 180 }}>Delivered At</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {(Array.isArray(items) ? items : []).length === 0 ? (
                                    <tr>
                                      <td colSpan={12} className="text-muted text-center">
                                        No products found for this order
                                      </td>
                                    </tr>
                                  ) : (
                                    items.map((it, i2) => {
                                      const qty = getItemQty(it);
                                      const unit = getItemPriceCents(it);
                                      const total = getItemTotalCents(it);

                                      const deliveryFee = getDeliveryFeeCents(order);
                                      const distanceKm = getDistanceKm(order);
                                      const eta = getEta(order);

                                      return (
                                        <tr key={`${orderId}-item-${i2}`}>
                                          <td>{orderNo}</td>
                                          <td>{getItemName(it)}</td>
                                          <td>{qty}</td>
                                          <td>
                                            {Currency.format
                                              ? Currency.format(unit)
                                              : `€${(unit / 100).toFixed(2)}`}
                                          </td>
                                          <td>
                                            {Currency.format
                                              ? Currency.format(total)
                                              : `€${(total / 100).toFixed(2)}`}
                                          </td>

                                          <td>{getDeliveryAddress(order)}</td>
                                          <td>{getDeliveryStatus(order) || "-"}</td>
                                          <td>
                                            {deliveryFee === null
                                              ? "-"
                                              : Currency.format
                                              ? Currency.format(deliveryFee)
                                              : `€${(deliveryFee / 100).toFixed(2)}`}
                                          </td>
                                          <td>{distanceKm === null ? "-" : distanceKm}</td>
                                          <td>{eta || "-"}</td>
                                          <td>{getDriverName(order) || "-"}</td>
                                          <td>{getDeliveredAt(order) || "-"}</td>
                                        </tr>
                                      );
                                    })
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
          
        )}
        <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap">
  <div className="text-muted mb-2">
    Showing{" "}
    {rows.length === 0
      ? 0
      : (this.state.currentPage - 1) * this.state.pageSize + 1}
    {" "}to{" "}
    {Math.min(this.state.currentPage * this.state.pageSize, rows.length)}
    {" "}of {rows.length} entries
  </div>

  <div className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
    <button
      className="btn btn-sm btn-light"
      disabled={this.state.currentPage <= 1}
      onClick={() =>
        this._goToPage(this.state.currentPage - 1, totalPages)
      }
    >
      Previous
    </button>

    <span className="font-weight-bold">
      Page {this.state.currentPage} of {totalPages}
    </span>

    <button
      className="btn btn-sm btn-light"
      disabled={this.state.currentPage >= totalPages}
      onClick={() =>
        this._goToPage(this.state.currentPage + 1, totalPages)
      }
    >
      Next
    </button>
  </div>
</div>
      </div>
    </div>
  );
}

  render() {
    const { totalEarnings } = this.state;

    return (
      <div className="container">
         <div className="row wd-100 mb-5">
          <div className="col-lg-4 col-md-6 mb-4">
            {" "}
             <StatsCard
               data={[
                 {
                  // statsInfo:
                  //   totalEarnings?.total_earnings &&
                  //   `${Currency.format(totalEarnings?.total_earnings)}`,
                  statsInfo: Currency.format
                      ? Currency.format(this._getAcceptedTotalRevenue())
                      : `€${(this._getAcceptedTotalRevenue() / 100).toFixed(2)}`,
                  title: "Total Revenue",
                  icon: (
                     <g
                       stroke="none"
                       strokeWidth={1}
                       fill="none"
                       fillRule="evenodd"
                     >
                       <rect x={0} y={0} width={24} height={24} />
                      <path
                         d="M4.3618034,10.2763932 L4.8618034,9.2763932 C4.94649941,9.10700119 5.11963097,9 5.30901699,9 L15.190983,9 C15.4671254,9 15.690983,9.22385763 15.690983,9.5 C15.690983,9.57762255 15.6729105,9.65417908 15.6381966,9.7236068 L15.1381966,10.7236068 C15.0535006,10.8929988 14.880369,11 14.690983,11 L4.80901699,11 C4.53287462,11 4.30901699,10.7761424 4.30901699,10.5 C4.30901699,10.4223775 4.32708954,10.3458209 4.3618034,10.2763932 Z M14.6381966,13.7236068 L14.1381966,14.7236068 C14.0535006,14.8929988 13.880369,15 13.690983,15 L4.80901699,15 C4.53287462,15 4.30901699,14.7761424 4.30901699,14.5 C4.30901699,14.4223775 4.32708954,14.3458209 4.3618034,14.2763932 L4.8618034,13.2763932 C4.94649941,13.1070012 5.11963097,13 5.30901699,13 L14.190983,13 C14.4671254,13 14.690983,13.2238576 14.690983,13.5 C14.690983,13.5776225 14.6729105,13.6541791 14.6381966,13.7236068 Z"
                         fill="#FF5E8A"
                        opacity="0.3"
                       />
                      <path
                        d="M17.369,7.618 C16.976998,7.08599734 16.4660031,6.69750122 15.836,6.4525 C15.2059968,6.20749878 14.590003,6.085 13.988,6.085 C13.2179962,6.085 12.5180032,6.2249986 11.888,6.505 C11.2579969,6.7850014 10.7155023,7.16999755 10.2605,7.66 C9.80549773,8.15000245 9.45550123,8.72399671 9.2105,9.382 C8.96549878,10.0400033 8.843,10.7539961 8.843,11.524 C8.843,12.3360041 8.96199881,13.0779966 9.2,13.75 C9.43800119,14.4220034 9.7774978,14.9994976 10.2185,15.4825 C10.6595022,15.9655024 11.1879969,16.3399987 11.804,16.606 C12.4200031,16.8720013 13.1129962,17.005 13.883,17.005 C14.681004,17.005 15.3879969,16.8475016 16.004,16.5325 C16.6200031,16.2174984 17.1169981,15.8010026 17.495,15.283 L19.616,16.774 C18.9579967,17.6000041 18.1530048,18.2404977 17.201,18.6955 C16.2489952,19.1505023 15.1360064,19.378 13.862,19.378 C12.6999942,19.378 11.6325049,19.1855019 10.6595,18.8005 C9.68649514,18.4154981 8.8500035,17.8765035 8.15,17.1835 C7.4499965,16.4904965 6.90400196,15.6645048 6.512,14.7055 C6.11999804,13.7464952 5.924,12.6860058 5.924,11.524 C5.924,10.333994 6.13049794,9.25950479 6.5435,8.3005 C6.95650207,7.34149521 7.5234964,6.52600336 8.2445,5.854 C8.96550361,5.18199664 9.8159951,4.66400182 10.796,4.3 C11.7760049,3.93599818 12.8399943,3.754 13.988,3.754 C14.4640024,3.754 14.9609974,3.79949954 15.479,3.8905 C15.9970026,3.98150045 16.4939976,4.12149906 16.97,4.3105 C17.4460024,4.49950095 17.8939979,4.7339986 18.314,5.014 C18.7340021,5.2940014 19.0909985,5.62999804 19.385,6.022 L17.369,7.618 Z"
                         fill="#FF5E8A"
                      />
                    </g>
                  ),
                 },
              ]}
             />{" "}
           </div>
           <div className="col-lg-4 col-md-6 mb-4">
             {" "}
             <StatsCard
               data={[
                 {
                   statsInfo: this._getMonthlySales(),
                   title: "Sales this month",
                   icon: (
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                       fillRule="evenodd"
                     >
                       <rect x={0} y={0} width={24} height={24} />
                       <path
                        d="M5.94290508,4 L18.0570949,4 C18.5865712,4 19.0242774,4.41271535 19.0553693,4.94127798 L19.8754445,18.882556 C19.940307,19.9852194 19.0990032,20.9316862 17.9963398,20.9965487 C17.957234,20.9988491 17.9180691,21 17.8788957,21 L6.12110428,21 C5.01653478,21 4.12110428,20.1045695 4.12110428,19 C4.12110428,18.9608266 4.12225519,18.9216617 4.12455553,18.882556 L4.94463071,4.94127798 C4.97572263,4.41271535 5.41342877,4 5.94290508,4 Z"
                         fill="#FF5E8A"
                        opacity="0.3"
                       />
                      <path
                         d="M7,7 L9,7 C9,8.65685425 10.3431458,10 12,10 C13.6568542,10 15,8.65685425 15,7 L17,7 C17,9.76142375 14.7614237,12 12,12 C9.23857625,12 7,9.76142375 7,7 Z"
                        fill="#FF5E8A"
                       />
                    </g>
                  ),
                },
               ]}
             />
           </div>
           <div className="col-lg-4 col-md-6 mb-4">
             {" "}
             <StatsCard
               data={[
                 {
                   statsInfo: this._getWeeklySales(),
                   title: "Sales this week",
                   icon: (
                    <g
                       stroke="none"
                       strokeWidth={1}
                      fill="none"
                     fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                       <rect
                        fill="#FF5E8A"
                         opacity="0.3"
                        x={7}
                         y={4}
                        width={10}
                        height={4}
                       />
                       <path
                         d="M7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 Z M8,12 C8.55228475,12 9,11.5522847 9,11 C9,10.4477153 8.55228475,10 8,10 C7.44771525,10 7,10.4477153 7,11 C7,11.5522847 7.44771525,12 8,12 Z M8,16 C8.55228475,16 9,15.5522847 9,15 C9,14.4477153 8.55228475,14 8,14 C7.44771525,14 7,14.4477153 7,15 C7,15.5522847 7.44771525,16 8,16 Z M12,12 C12.5522847,12 13,11.5522847 13,11 C13,10.4477153 12.5522847,10 12,10 C11.4477153,10 11,10.4477153 11,11 C11,11.5522847 11.4477153,12 12,12 Z M12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 C11.4477153,14 11,14.4477153 11,15 C11,15.5522847 11.4477153,16 12,16 Z M16,12 C16.5522847,12 17,11.5522847 17,11 C17,10.4477153 16.5522847,10 16,10 C15.4477153,10 15,10.4477153 15,11 C15,11.5522847 15.4477153,12 16,12 Z M16,16 C16.5522847,16 17,15.5522847 17,15 C17,14.4477153 16.5522847,14 16,14 C15.4477153,14 15,14.4477153 15,15 C15,15.5522847 15.4477153,16 16,16 Z M16,20 C16.5522847,20 17,19.5522847 17,19 C17,18.4477153 16.5522847,18 16,18 C15.4477153,18 15,18.4477153 15,19 C15,19.5522847 15.4477153,20 16,20 Z M8,18 C7.44771525,18 7,18.4477153 7,19 C7,19.5522847 7.44771525,20 8,20 L12,20 C12.5522847,20 13,19.5522847 13,19 C13,18.4477153 12.5522847,18 12,18 L8,18 Z M7,4 L7,8 L17,8 L17,4 L7,4 Z"
                         fill="#FF5E8A"
                      />
                   </g>
                 ),
                },
               ]}
            />{" "}
          </div>
        </div>

















        {/* GRAPH */}
        <div className="row wd-100 mb-5">
          <div className="col-md-12">
            <div className="card card-custom gutter-b">
              <div className="card-header">
                <div className="card-title">
                  <h3 className="card-label">Sales Numbers</h3>
                </div>
              </div>
              <div className="card-body" style={{ position: "relative" }}>
                {this._renderGraphs()}
              </div>
            </div>
          </div>
        </div>

        {/* ✅ SALES TABLE */}
        <div className="row wd-100 mb-5">
          <div className="col-md-12">{this._renderSalesTable()}</div>
        </div>
      </div>
    );
  }
}
